<template>
  <div>
    <v-dialog card max-width="80vw">
      <template v-slot:activator="{ on }">
        <div>
          Primary Work Address:
          <strong v-if="addresses.find(a => a.isprimary)">
            {{ addresses.find(a => a.isprimary).facility.name }}
          </strong>
          <v-btn text outlined v-on="on" small>
            Add/edit
          </v-btn>
        </div>
      </template>
      <v-card>
        <!-- <v-card-header> -->
        <v-card-title>
          Work Addresses
        </v-card-title>

        <v-container fluid>
          <v-form :disabled="!currentUserCan('editAddresses')">
            <v-simple-table>
              <template #default>
                <thead>
                  <tr width="10em">
                    <th>
                      Is Primary?
                    </th>
                    <th>
                      Facility
                    </th>
                    <th>
                      Facility Info
                    </th>
                    <th>Updated</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <v-checkbox
                        v-model="newAddr.isprimary"
                        hide-details
                        class="shrink"
                        :disabled="!currentUserCan('editAddresses')"
                      />
                    </td>
                    <td colspan="3">
                      <hpi-facility-select
                        v-model="newAddr.hpi"
                        :loading="loading"
                        :disabled="!currentUserCan('editAddresses')"
                      >
                        <template #append-outer> </template>
                      </hpi-facility-select>
                    </td>
                    <td>
                      <v-btn
                        @click="addAddress"
                        icon
                        outlined
                        :disabled="!currentUserCan('editAddresses')"
                      >
                        <v-icon>
                          save
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>

                  <work-address
                    v-for="address in addresses"
                    :address="address"
                    :key="`workAddress-${address.id}`"
                    @change="loadResources"
                    :disabled="!currentUserCan('editAddresses')"
                  />
                  <work-address
                    class="inactive"
                    v-for="address in oldAddresses"
                    :address="address"
                    :key="`workAddress-${address.id}`"
                    :disabled="!currentUserCan('editAddresses')"
                    @change="loadResources"
                  />
                </tbody>
              </template>
            </v-simple-table>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import workAddress from "./single";
import hpiFacilitySelect from "./hpi-facility-search";

export default {
  name: "WorkAddressList",
  data() {
    return {
      person: {},
      practitioner: {},
      apc: [],
      qualifications: [],
      addresses: [],
      errors: [],
      loading: false,
      showNewForm: false,
      newAddr: { isprimary: true, hpi: "" },
      oldAddresses: []
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup" })
  },
  methods: {
    async loadResources() {
      if (!this.personId) {
        this.errors.push("personid not defined");
        return;
      }
      this.$store.dispatch("load", this.personId);
      this.loading = true;
      var reqs = [];

      reqs.push(
        this.$http
          .get("/workaddresses/", {
            params: {
              filter: {
                where: { personid: this.personId },
                order: "inactiveat desc, isprimary desc, createdat desc"
              }
            }
          })
          .then(response => {
            this.loading = false;
            this.addresses = [...response.data.filter(addr => addr.active)];
            this.oldAddresses = [...response.data.filter(addr => !addr.active)];
            this.errors = [];
          })
          .catch(e => {
            this.loading = false;
            this.handleError(e);
          })
      );
    },
    handleError(e) {
      this.errors.push(e.message);
    },
    async addAddress() {
      if (this.newAddr.hpi) {
        try {
          this.loading = true;
          this.newAddr.personid = this.personId;
          let res = await this.$http.patch("workaddresses", this.newAddr);
          if (res.data.id) {
            this.newAddr.hpi = "";
          }
          this.$store.dispatch("load", this.personId);
          this.loadResources();
        } finally {
          this.loading = false;
        }
      }
    }
  },
  props: {
    personId: String
  },
  watch: {
    personId: {
      handler: "loadResources",
      immediate: true
    }
  },
  components: {
    hpiFacilitySelect,
    workAddress
  }
};
</script>

<style scoped>
tr.inactive,
tr.inactive:hover {
  background-color: lightgrey;
}
</style>
